import React, { Component } from 'react';
import { connect } from 'react-redux';
import ResellerGoogleMap from "./ResellerGoogleMap";
import { load } from "../Actions/ResellerGoogleMap.action";
import { lifecycle } from 'recompose';
import {getCookie} from "../Shared/Utils";

let ResellerGoogleMapContainer = (props) => <ResellerGoogleMap {...props} />
 
const mapStateToProps = state => {
    return {
        resellerData: state.reseller.resellerData,
        countries: state.reseller.countries,
        isGlobalChannel: state.reseller.isGlobalChannel,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
    }
}

ResellerGoogleMapContainer = lifecycle({
    componentWillMount() {
        const { load } = this.props;
        load();
    },
})(ResellerGoogleMapContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResellerGoogleMapContainer);
